module.exports = __webpack_public_path__ + "static/CFG_Artist_Downtown-7280a43aff7bc5982906754338645700.jpg";